import { useEffect, useState } from "react";
import { getImageUrlWithSas } from "../../services/SAS";

const BlogImage = ({ imageUrl, alt, className }) => {
  const [url, setUrl] = useState('https://www.fetchjobs.co/static/media/fetchjobLogo.aa2faf0113cf3ef779e0.png');

  useEffect(() => {
    const fetchImage = async () => {
      if (imageUrl && imageUrl !== "") {
        try {
          const response = await getImageUrlWithSas(imageUrl);
          setUrl(response.data.url);
        } catch (error) {
          console.error("Error fetching image URL:", error);
        }
      }
    };
    fetchImage();
  }, [imageUrl]);

  return <img src={url} alt={alt} className={className} />;
};

export default BlogImage;
